import React, { useEffect } from "react";
import { Auth0Provider } from "@auth0/auth0-react";
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import './index.css';
import LandingPage from './pages/docomo/LoginPage.js';
import DisplaySupportIdPage from './pages/docomo/SupportIdPage.js';
import CreateSubscriptionPage from './pages/docomo/CreateSubscription.js';
import DocomoHandler from "./pages/docomo/DocomoHandler";
import AiaHandler from "./pages/aia/AiaHandler";
import SecureAuth0Handler from "./pages/aia/SecureAuth0Handler";
import TMobileDownloadPage from "./pages/tmobile/TMobileDownloadPage";
import MetroDownloadPage from "./pages/metro/MetroDownloadPage";
import QtNetHandler from "./pages/qtNet/QtNetHandler";
import "@mcafee/tokens-assemble-css";



function MobileDownloadPageRouter() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const partner = params.get("partner");
  const hostname = window.location.host.toLowerCase();

  if (hostname.includes("metro")) {
    return <MetroDownloadPage />;
  }

  if (hostname.includes("tmobile")) {
    return <TMobileDownloadPage />;
  }

  // Fallback to query parameter if hostname doesn't match
  if (partner === "metro") {
    return <MetroDownloadPage />;
  }

  if (partner === "tmobile") {
    return <TMobileDownloadPage />;
  }

  // Default to T-Mobile if neither hostname nor parameter found
  return <TMobileDownloadPage />;
}

function RedirectBasedOnAffId() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const affId = params.get("affid");
    const action = params.get("Action");

    if ((affId === "1460") && (action === 'dAccountLogin')) {
      navigate("/LogIn");
    }
    if ((affId === "1460") && (action === 'DisplaySupportId')) {
      navigate("/DisplaySupportId");
    }
    if ((affId === "1460") && (action === 'CollectSupportId')) {
      navigate("/CollectSupportId");
    }
  }, [location, navigate]);

  return null;
}


export default function App() {
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AIA_AUTH_DOMAIN}
      clientId={process.env.REACT_APP_AIA_AUTH0_CLIENT_ID}
      authorizationParams={{
    redirect_uri: process.env.REACT_APP_AIA_AUTH_REDIRECT_URL,
    audience: process.env.REACT_APP_AIA_AUDIENCE, // if needed
    scope: "openid profile email"
  }}
    >
      <Router>
        <RedirectBasedOnAffId />
        <Routes>
          <Route path="/" element={<div>Not Implemented</div>} />
          <Route path="/LogIn" element={<LandingPage />} />
          <Route path="/DisplaySupportId" element={<DisplaySupportIdPage />} />
          <Route path="/CollectSupportId" element={<CreateSubscriptionPage />} />
          <Route path="/DocomoHandler" element={<DocomoHandler />} />
          <Route path="/partnerpages/aia/register.aspx" element={<AiaHandler />} />
          <Route path="/aia/auth0redirect" element={<SecureAuth0Handler />} />
          <Route path="/mobile" element={<MobileDownloadPageRouter />} />
          <Route path="/partnerpages/signuppage.aspx" element={<QtNetHandler />} />
        </Routes>
      </Router>
    </Auth0Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);